module.exports = __webpack_public_path__ + "static/media/icon-arrow-sidebarClosed.56d626fb.svg";